sap.ui.require(["sap/ui/core/Core"], (Core) => Core.boot?.());
